import { render } from "./ProjectCard.vue?vue&type=template&id=48cfb505&scoped=true"
import script from "./ProjectCard.vue?vue&type=script&lang=js"
export * from "./ProjectCard.vue?vue&type=script&lang=js"

import "./ProjectCard.vue?vue&type=style&index=0&id=48cfb505&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48cfb505"]])

export default __exports__